var isWidget = require("../vnode/is-widget.js")

module.exports = updateWidget

function updateWidget(a, b) {
    if (isWidget(a) && isWidget(b)) {
        if ("name" in a && "name" in b) {
            return a.id === b.id
        } else {
            return a.init === b.init
        }
    }

    return false
}



//////////////////
// WEBPACK FOOTER
// ./~/virtual-dom/vdom/update-widget.js
// module id = 186
// module chunks = 0